import { Metric } from '../metric/metric';
import { TaskGroupInfo } from '../tasklist/tasklist';
import { UserGroup } from '../user/user';
import { SimpleResponse } from '../response-models/response-models';
import { ReasonType, WOTypeCategory } from '../global-entities/global-enums';

export class KMTMaster {
  public AssetCategories: Array<AssetCategoryLookup>;
  public PMTypes: Array<PMType>;
  public MeasurementUnits: Array<MeasurementUnit>;
  public Metrics: Array<Metric>;
  public TaskGroups: Array<TaskGroupInfo>;
  public UserGroups: Array<UserGroup>;
}

export type KMTMasterResponse = SimpleResponse<KMTMaster>;

export class KMTMastersExtDTO {
  public Reasons: Reason[];
  public Descriptions: WODescription[];
  public WorkOrderTypes: WorkOrderType[];
  public Currency: Currency[];
  public DepartmentWhitelists: WhitelistDept[];
}

export type KMTMastersExtDTOResponse = SimpleResponse<KMTMastersExtDTO>;

export class AssetCategoryLookup {
  public AssetCategoryId: number;
  public PropertyId: number;
  public Name: string;
  public ParentId?: number;
  public Level?: number;
  public Path: string;

  static generateModelFromRequest(Result: any): AssetCategoryLookup {
    const obj = new AssetCategoryLookup();
    obj.AssetCategoryId = Result.AssetCategoryId;
    obj.ParentId = Result.ParentId;
    obj.Name = Result.Name;
    obj.PropertyId = Result.PropertyId;
    return obj;
  }
}

export class PMType {
  public PMTypeId: number;
  public Name: string;
}

export class MeasurementUnit {
  public MeasurementUnitId: number;
  public Name: string;
}

export class Reason {
  public Id: number;
  public ChainId: number;
  public Description: string;
  public ReasonType: ReasonType;
  public IsDefault = false;
  public IsDel = false;
  public ReasonTypeName?: string;
  public KsvReasonId?: number;
}

export class WODescription {
  public Id: number;
  public PropertyId: number;
  public ChainId: number;
  public WorkOrderDescription?: string;
  public IsDel = false;
  public Type?: string;
}

export class WorkOrderType {
  Id: number;
  PropertyId: number;
  ChainId: number;
  Description: string;
  TypeId: WOTypeCategory;
  IsDefault?: boolean;
}
export class Currency {
  Id: number;
  PropertyId: number;
  ChainId: number;
  Currency: string;
  Symbol: string;
}

export class WhitelistDept {
  Id: number;
  ChainId: number;
  DepartmentId: number;
}
